import styled from 'styled-components';

export const BadgeGroupWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
`;
